<template>
	<div>
		<Header></Header>
		<Search></Search>
		<Nav></Nav>
		<div class="integral">
			<div class="integralbanner" :style="backgroundimg">
				<div class="w clearfloat">
					<div class="integralbanright">
						<div class="integratitle">
							<div class="integratitleimg">
								<img src="../../assets/images/img1.jpg" alt="">
							</div>
							<h5>HI,<span>小胖丫</span></h5>
						</div>
						<div class="zintegral">
							<h5>20000</h5>
							<p>积分</p>
						</div>
						<div class="integraltext clearfloat">
							<span>我的兑换</span>
							<span>积分明细</span>
						</div>
					</div>
				</div>
			</div>
			
			<div class="integralnav">
				<div class="w">
					<div class="integralnavcon">
						<ul class="clearfloat">
							<li>全部</li>
							<li>男装女装</li>
							<li>家用电器</li>
							<li>手机数码</li>
							<li>护肤美肤</li>
							<li>家居家纺</li>
							<li>电脑办公</li>
						</ul>
					</div>
				</div>
			</div>
			
			<div class="integralast">
				<div class="w">
					<div class="integracon">
						<div class="integraconnav">
							<ul class="clearfloat">
								<li class="active"><span>综合</span></li>
								<li>
									<span>兑换量</span>
									<i><img src="../../assets/images/inonxl.png" alt/></i>
									<!-- 向下颜色 -->
									<i style="display: none;"><img src="../../assets/images/indown.png" alt/></i>
									<!-- 向上颜色 -->
									<i style="display: none;"><img src="../../assets/images/iconinup.png" alt/></i>
								</li>
								<li>
									<span>价格</span>
									<i><img src="../../assets/images/filtrate_pic.svg" alt/></i>
								</li>
							</ul>
						</div>
						
						<div class="integraconter">
							<!-- 商品列表 -->
							<div class="integracontered">
								<div class="integralist">
									<ul class="clearfloat">
										<li v-for="(item,index) in 15" :key="index">
											<div class="interalimg">
												<img src="../../assets/images/img.jpg" alt="">
												<div class="interalimgtext">
													立即兑换
												</div>
											</div>
											
											<div class="img-list d-flex" :class="['img-list','img-list'+index]">
												<div class="swiper-container img-listcon swiper-no-swiping">
													<div class="clearfloat swiper-wrapper">
														<div class="img-item swiper-slide" >
															<img class="img" src="../../assets/images/img.jpg"  />
														</div>
														<div class="img-item swiper-slide" >
															<img class="img" src="../../assets/images/img.jpg"  />
														</div>
														<div class="img-item swiper-slide" >
															<img class="img" src="../../assets/images/img.jpg"  />
														</div>
														<div class="img-item swiper-slide" >
															<img class="img" src="../../assets/images/img.jpg"  />
														</div>
														<div class="img-item swiper-slide" >
															<img class="img" src="../../assets/images/img.jpg"  />
														</div>
													</div>
												</div>
												<!-- 左右箭头 -->
												<div class="swiper-button-prev ttshop_prev"></div>
												<div class="swiper-button-next ttshop_next"></div>
											</div>
											<div class="interaltext">
												<h6><span>20000 <strong>积分</strong></span> <b>+</b> <span>￥98.00</span></h6>
												<h5>李宁外套男官方正品2020夏秋季连帽宽九牧 JOMOO 防烫空气能升降淋浴花洒</h5>
												<p><span>210</span>人兑换</p>
											</div>
											
										</li>
									</ul>
								</div>
								<!-- 分页 -->
								<div class="ttshop_myorderpage clearfloat">
									<el-pagination class="ttshop_pages" background layout="prev, pager, next" :total="40"></el-pagination>
								</div>
							</div>
							<!-- 暂无商品时暂时 -->
							<template>
								<div class="zanwugoods">
									<img src="../../assets/images/ttshop_zanwu.png" alt="">
									<p>暂无商品</p>
								</div>
							</template>
						</div>
					</div>
				</div>
			</div>
			
		</div>
		<Foot></Foot>
	</div>
</template>

<script>
	import Header from "@/components/header/header";
	import Search from "@/components/search/search";
	import Nav from "@/components/nav/nav";
	import Foot from "@/components/foot/foot";
	import {Swiper,SwiperSlide} from "vue-awesome-swiper";
	export default {
		components: {
			Search,
			Header,
			Nav,
			Foot,
		},
		data() {
			return {
				backgroundimg: {
					backgroundImage: "url(" + require("../../assets/images/baners.jpg") + ")",
				},
				value: 4,
			};
		},
		created() {
			this.lunbo();
		},
		methods: {
			lunbo(){
				for (let i = 0; i < 10; i++) {
					let element = ".img-list" + i + " .img-listcon";
					let nextEl = ".img-list" + i + " .ttshop_next";
					let prevEl = ".img-list" + i + " .ttshop_prev";
					let mySwiper = new Swiper(element, {
						loop: false, // 循环模式选项
						slidesPerView: 5,
						spaceBetween: 5,
						observer: true,
						observeParents: true,
						navigation: {
							nextEl: nextEl,
							prevEl: prevEl,
						}
					});
				}
			}
		},
	};
</script>

<style lang="scss" scoped>
	.integral{
		width: 100%;
		height: 100%;
		.integralbanner{
			width: 100%;
			height: 350px;
			background-repeat: no-repeat;
			background-position: center;
			background-size: cover;
			padding-top: 53px;
			box-sizing: border-box;
			.integralbanright{
				float: right;
				width: 190px;
				height: 244px;
				background: #fff;
				padding: 32px 12px;
				box-sizing: border-box;
				.integratitle{
					width: 100%;
					margin-bottom: 20px;
					.integratitleimg{
						width: 36px;
						height: 36px;
						border-radius: 50%;
						margin: 0 auto 12px;
						img{
							display: block;
							width: 100%;
							height: 100%;
							object-fit: cover;
							border-radius: 50%;
						}
					}
					h5{
						font-size: 12px;
						color: #333;
						font-weight: 400;
						line-height: 12px;
						text-align: center;
					}
				}
				.zintegral{
					width: 100%;
					margin-bottom: 20px;
					h5{
						font-size: 32px;
						color: #FF4300;
						font-weight: 400;
						line-height: 32px;
						text-align: center;
						margin-bottom: 10px;
					}
					p{
						font-size: 12px;
						color: #333;
						text-align: center;
						font-weight: 400;
						line-height: 12px;
					}
				}
				.integraltext{
					width: 100%;
					span{
						float: left;
						width: 77px;
						height: 26px;
						border-radius: 13px;
						text-align: center;
						line-height: 26px;
						font-size: 12px;
						color: #fff;
						transition: .5s;
						-moz-transition: .5s;
						-webkit-transition: .5s;
						-o-transition: .5s;
						background: #FF0E25;
						margin-right: 12px;
						cursor: pointer;
						&:last-child{background: #FF9010;margin-right: 0;}
						&:first-child:hover{box-shadow: 0 5px 10px rgba(255,14,37,0.2);}
						&:last-child:hover{box-shadow: 0 5px 10px rgba(255,144,16,0.2);}
					}
				}
			}
		}
		.integralnav{
			width: 100%;
			background: #FAFAFA;
			padding: 14px 0 2px 0;
			box-sizing: border-box;
			.integralnavcon{
				width: 100%;
				ul{
					li{
						float: left;
						font-size: 12px;
						color: #333;
						position: relative;
						font-weight: 400;
						line-height: 12px;
						margin: 0 16px;
						cursor: pointer;
						transition: .5s;
						-moz-transition: .5s;
						-webkit-transition: .5s;
						-o-transition: .5s;
						margin-bottom: 12px;
						&::before{
							content: '';
							width: 1px;
							height: 12px;
							background: #D8D8D8;
							position: absolute;
							top: 0;
							right: -16px;
						}
						&:first-child{margin-left: 0;}
						&:last-child::before{display: none;}
						&:hover{color: #FF0E25;}
					}
				}
			}
		}
		.integralast{
			width: 100%;
			background: #fff;
			padding: 20px 0 60px 0;
			box-sizing: border-box;
			.integracon{
				width: 100%;
				.integraconnav{
					width: 100%;
					margin-bottom: 20px;
					ul{
						li{
							float: left;
							cursor: pointer;
							margin-right: 28px;
							span{
								font-size: 12px;
								color: #666;
								font-weight: 400;
								line-height: 12px;
								transition: .5s;
								-moz-transition: .5s;
								-webkit-transition: .5s;
								-o-transition: .5s;
							}
							i{
								display: inline-block;
								width: 12px;
								height: 12px;
								vertical-align: -2px;
							}
							&:last-child{margin-right: 0;}
							&:hover span{color: #FF0E25;}
							&.active span{color: #FF0E25;}
						}
					}
				}
				.integraconter{
					width: 100%;
					.integracontered{
						width: 100%;
						.integralist{
							width: 100%;
							ul{
								li{
									float: left;
									width: 234px;
									height: 384px;
									background: #fff;
									transition: .5s;
									-moz-transition: .5s;
									-webkit-transition: .5s;
									-o-transition: .5s;
									padding: 8px 12px 14px 12px;
									box-sizing: border-box;
									margin-bottom: 28px;
									margin-right: 5px;
									.interalimg{
										width: 214px;
										height: 214px;
										overflow: hidden;
										position: relative;
										margin-bottom: 8px;
										img{
											display: block;
											width: 100%;
											height: 100%;
											object-fit: cover;
										}
										.interalimgtext{
											width: 100%;
											height: 28px;
											font-size: 12px;
											color: #fff;
											text-align: center;
											line-height: 28px;
											padding: 0 10px;
											box-sizing: border-box;
											background: #FF0E25;
											position: absolute;
											left: 0;
											bottom: -30px;
											opacity: 0;
											transition: .5s;
											-moz-transition: .5s;
											-webkit-transition: .5s;
											-o-transition: .5s;
											cursor: pointer;
										}
									}
									.img-list {
										width: 100%;
										padding: 0 19px;
										box-sizing: border-box;
										margin-top: 8px;
										position: relative;
										margin-bottom: 12px;
										.img-listcon {
											width: 100%;
											padding: 0 1px;
											box-sizing: border-box;
									
											.img-item {
												width: 31px !important;
												height: 31px;
												padding: 2px;
												border: 1px solid #ebebeb;
												box-sizing: border-box;
												margin-right: 4px;
												transition: .5s;
												-moz-transition: .5s;
												-webkit-transition: .5s;
												-o-transition: .5s;
												cursor: pointer;
									
												.img {
													width: 100%;
													height: 100%;
												}
									
												&:hover {
													border-color: #FF0E25;
												}
									
												&:last-child {
													margin-right: 0 !important;
												}
											}
										}
									
										.ttshop_prev {
											width: 14px;
											height: 14px;
											margin-top: -7px;
											background: url(../../assets/images/ttshop_scleft.png) center no-repeat;
											left: 0;
											cursor: pointer;
											z-index: 100;
											outline: none;
										}
									
										.ttshop_next {
											width: 14px;
											height: 14px;
											margin-top: -7px;
											background: url(../../assets/images/ttshop_scright.png) center no-repeat;
											right: 0;
											cursor: pointer;
											z-index: 100;
											outline: none;
										}
									}
									.interaltext{
										width: 100%;
										h6{
											margin-bottom: 8px;
											font-weight: 500;
											span{
												font-size: 20px;
												color:#FF4300;
												strong{
													font-size: 12px;
													color: #999;
													font-weight: 400;
													vertical-align: 1px;
												}
											}
											b{
												font-size: 14px;
												color: #D8D8D8;
												font-weight: 400;
												vertical-align: 2px;
											}
										}
										h5{
											display: block;
											font-size: 12px;
											color: #666;
											font-weight: 400;
											line-height: 18px;
											height: 36px;
											display: -webkit-box; -webkit-box-orient: vertical; -webkit-line-clamp: 2; overflow: hidden;
											margin-bottom: 10px;
											transition: .5s;
											-moz-transition: .5s;
											-webkit-transition: .5s;
											-o-transition: .5s;
										}
										p{
											font-size: 12px;
											color: #999;
											font-weight: 400;
											line-height: 12px;
											span{
												font-size: 12px;
												line-height: 12px;
												color: #0E9CFF;
												margin-right: 6px;
											}
										} 
									}
									&:nth-child(5n){margin-right: 0;}
									&:hover{box-shadow: 0px 0px 12px 0px rgba(0, 0, 0, 0.1);}
									&:hover .interalimg .interalimgtext{bottom: 0;opacity: 1;}
									&:hover .interaltext h5{color: #FF0E25;}
								}
							}
						}
						.ttshop_myorderpage{  
							width: 100%;
							margin-top: 20px;
							.ttshop_pages{
								display: table;
								margin: 0 auto;
							}
						}
					}
					// 暂无商品
					.zanwugoods {
						width: 100%;
						padding: 150px 0;
						box-sizing: border-box;
						display: none;
					
						img {
							display: block;
							width: 93px;
							height: 80px;
							margin: 0 auto 20px;
						}
					
						p {
							font-size: 16px;
							color: #333;
							text-align: center;
						}
					}
				}
			}
		}
	}
</style>


